// export * from './global.d';
// export * from './modal-viewer.d';
export default {};
